// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";

function Loader(props) {
  let __showText = props.showText;
  let __showText_value = __showText !== undefined ? __showText : true;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("span", {
            children: "Loading...",
            className: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
          }),
          className: "inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[#0069FD] border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
          role: "status"
        }),
        className: "flex flex-row gap-10"
      }),
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: __showText_value,
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "We are processing your payment...",
              className: "font-semibold text-sm text-gray-200 self-center "
            }),
            JsxRuntime.jsx("div", {
              children: "You have been redirected to new tab to complete your payments. Status will be updated automatically",
              className: "font-medium text-xs text-gray-400 self-center text-center w-3/4 "
            })
          ],
          className: "flex flex-col gap-5"
        })
      })
    ],
    className: "flex flex-col gap-10 justify-center items-center"
  });
}

let make = Loader;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
